/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';

import COLORS from '../../styles/Colors';

import { I18nImage } from '../../components/I18nTranslation';
import GroupMetadata, { GroupMetadataType } from '../../../models/GroupMetadata';

interface Props {
  group: GroupMetadataType;
  size: string;
  backgroundColor: string;
  noBorder?: boolean;
  hasDropshadow?: boolean;
  intl: any;
}

const GroupLogo = (props: Props) => {
  const locale = props.intl.locale;
  const { group, size, backgroundColor, noBorder, hasDropshadow } = props;
  const groupMeta = new GroupMetadata(group);
  const borderColor = noBorder ? 'transparent' : COLORS.gsMiddleDT;
  const className = hasDropshadow ? '_dropshadow' : null;
  const hasIcon = groupMeta.imagesIcon.hasValue(props.intl.locale) || groupMeta.imagesIcon.hasValue();

  return (
    <div className="cmp-grouplogo">
      {
        hasIcon
        ? <I18nImage data={groupMeta.imagesIcon.get()} className={className} style={{ borderRadius: '4px', borderColor }} width={size} height={size} />
        : (
          <div className={classnames('img', className)} style={{ height: size, width: size, backgroundColor, borderColor }}>
            <span>{groupMeta.groupName.getInitials(locale)}</span>
          </div>
        )
      }
    </div>
  );
};

export default injectIntl(GroupLogo);
